<ws-modal-wrapper headerLabel="Apply Applicable Digital Signatures"
                  [hideFooter]="true"
                  (cancel)="cancel()">
    <ag-grid-row-count [gridApi]="gridApi"
                       [gridOptions]="gridOptions"
                       [prefix]="null"
                       [suffix]="null"></ag-grid-row-count>
    <ws-ag-grid-angular wrapperClass="app-ui-view return-sign-modal-list"
                        [gridOptions]="gridOptions"
                        (gridReady)="onAgGridReady($event)"
                        [gridId]="gridId">
    </ws-ag-grid-angular>
    <div class="modal-footer">
        <div class="ws-button-row-warning">
            <warning-message [message]="wetSignatureOverrideWarning"
                             [show]="!!wetSignatureOverrideWarning"
                             [hasDetails]="false">
            </warning-message>
        </div>
        <div class="ws-button-row">
            <button class="ace-btn btn-primary" (click)="save()" [disabled]="!isValid">OK</button>
            <button class="ace-btn btn-primary btn-danger" helpTooltip
                    helpContentId="return-sign.skip-button"
                    position="bottom"
                    (click)="skip()">
                Skip
            </button>
            <button class="ace-btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    </div>
</ws-modal-wrapper>
